import React, { useContext } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import StoreContext from '~/context/StoreContext'
import LineItem from './LineItem'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../utils/fontawesome'
import cartIcon from '../../img/cart.svg'

const Cart = () => {
  const {
    store: { checkout },

  } = useContext(StoreContext)

  const handleCheckout = () => {
    window.open(checkout.webUrl)
  }

  const line_items = checkout.lineItems.map(line_item => {
    return <LineItem key={line_item.id.toString()} line_item={line_item} />
  })

  return (
    <Panel>
      <h1 className='title is-4' style={{ color: '#161c27' }}>Warenkorb{' '}<img src={cartIcon} style={{ width: '1.5rem' }} alt='cart-icon' /></h1>
      {checkout.lineItems.length === 0 ? <><h2 className='subtitle is-5' style={{ color: '#161c27' }}>Dein Warenkorb ist leer</h2><img src={cartIcon} alt='cart-icon' style={{ width: '120px' }} />{' '}<Link to='/#products' className='button is-medium is-primary is-outlined' style={{ margin: '2rem' }}>JETZT SHOPPEN</Link></> :
        <div>
          {line_items}
          <div className='columns is-multiline is-mobile'>
            <div className='column is-2' />
            <div className='column is-10'>

              <div className='column is-12'>
                <h2 className='subtitle is-6 has-text-weight-medium' style={{ color: '#161c27', display: 'inline-block' }}>Zwischensumme:</h2>
                <p className='has-text-weight-bold' style={{ float: 'right' }}>€ {checkout.subtotalPrice}</p>
              </div>

              <div className='column is-12'>
                <h2 className='subtitle is-6 has-text-weight-medium' style={{ color: '#161c27', display: 'inline-block' }}>Mwst.:</h2>
                <p className='has-text-weight-bold' style={{ float: 'right' }}>€ {checkout.totalTax}</p>
              </div>
              <div className='column is-12'>
                <h3>Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.</h3>
              </div>

              <div className='column is-12'>
                <h2 className='subtitle is-6 has-text-weight-bold' style={{ color: '#161c27', display: 'inline-block' }}>Gesamtsumme:</h2>
                <p className='has-text-weight-bold' style={{ float: 'right' }}>€ {checkout.totalPrice}</p>
              </div>
            </div>


          <div className='column is-12 has-text-centered'>
            <button className='button is-medium is-primary' onClick={handleCheckout} disabled={checkout.lineItems.length === 0} style={{ width: '250px' }}>Check out&nbsp;<FontAwesomeIcon icon='angle-right' /></button>
          </div>

          <div className='column is-12 has-text-centered'>
            <Link to='/#produkte' className='button is-medium is-primary is-outlined' style={{ width: '250px' }}><FontAwesomeIcon icon='angle-left' />&nbsp;Weitershoppen
            </Link>
          </div>
          </div>
        </div>}
    </Panel>
  )
}

export default Cart

const Panel = styled.div`
  border-radius: 3px;
  margin: 0 auto;
  max-width: 600px;
  box-shadow: 0 0 10px rgba(0,0,0,.1);
  padding: 20px;
`
